import React, { Component } from 'react';
import { Card, Row, Col, Input, ButtonGroup, Button, Table, Alert as Alert2 } from "reactstrap";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, stringHelper, filterHelper } from "../helpers";
import { TextFilter, FilterSet, ActiveToggleFilter, Pager} from "../components";
import { Link } from "react-router-dom";
import Select from "react-select";

const emptyUser = {
  firstName: '',
  lastName: '',
  email: '',
  roles: [],
  typeOfRole: null,
  //initPassword: '',
  unlockAccount: false
}

const getRoles = () => api.fetch('Reference/Roles').then(response => {
  return {
    roleList: _.map(response.data, x => {
      x.label = x.name;
      x.value = x.id;
      return x
    })
  };
}).catch(x => console.error(x));

const formatUser = (list) => {
  return _.forEach(list, item => {
    item.roles = _.map(item.userRoles, r => {
      return {
        label: r.roleName,
        value: r.roleId
      };
    })
    item.roleNameList = _.map(item.roles, r => r.label);
    return item;
  });
}

export default class User extends Component {
  static displayName = User.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      editUser: null,
      usersList: [],
      roleList: [],
      filters: [],
      pagedList: null,
      sortColumn: "Id",
      sortAscending: true,

    }
    this.refreshList = this.refreshList.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.validEmailEntered = this.validEmailEntered.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.getUserName = this.getUserName.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);

  }

  componentDidMount() {
    Promise.all([getRoles()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => {
          this.onChangeFilter({
            filterName: "activeOnly",
            value: true,
            filteredDisplay: "Active Only"
          });
        }
      );
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/Users", payload)
      .then(response => {
        this.setState({
          ...resolvedSort,
          pagedList: {
            list: formatUser(response.data.dataSource),
            pageNumber: response.data.page,
            pageSize: response.data.pageSize,
            totalItems: response.data.totalItems,
            totalPages: response.data.totalPages
          },
          filters: resolvedFilters,
          editUser: null,
          message: null,
          messageColor: null,
          isMessageVisible: false,
        });
      })
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  addUser() {
    this.setState({
      editUser: emptyUser
    })
  }

  onInputChange(e, fieldName) {
    this.setState({
      editUser: { ...this.state.editUser, [fieldName]: e.target.value }
    })
  }

  onSelectChange(selection, fieldName) {
    this.setState({
      editUser: {
        ...this.state.editUser, [fieldName]: fieldName === "roles"
          ? selection : selection.target.value
      }
    })
  }

  onCancel() {
    this.setState({
      editUser: null
    });
  }

  validEmailEntered(email) {
    return stringHelper.emailIsValid(email) ? false : true;
  }

  isFormValid() {
    let warnings = [];
    if (this.state.editUser.firstName === '') {
      warnings.push("Please enter first name");
    }
    if (this.state.editUser.lastName === '') {
      warnings.push("Please enter last name");
    }
    if (this.state.editUser.email === '') {
      warnings.push("Please enter email");
    }
    if (this.state.editUser.email && this.validEmailEntered(this.state.editUser.email)) {
      warnings.push("Please enter a valid email");
    }

    if (this.state.editUser.roles.length === 0) {
      warnings.push("Please select a role");
    }

    this.setState({ message: (warnings.length ? warnings.join(", ") : null), messageColor: "danger", isMessageVisible: true });
    return warnings.length === 0;
  }

  onCheckBoxChange(fieldName) {
    this.setState({
      editUser: {
        ...this.state.editUser, [fieldName]: !this.state.editUser[fieldName],
      }
    });
  }

  onEdit(userId) {
    let list = this.state.pagedList.list.slice();
    let user = _.find(list, u => {
      return u.id === userId
    })

    this.setState({
      editUser: user
    })
  }

  onSave() {
    if (!this.isFormValid()) return;
    let user = Object.assign({}, this.state.editUser);
    let payload = {
      FirstName: user.firstName,
      LastName: user.lastName,
      Email: user.email,
      Roles: _.map(user.roles, x => { return x.value })
      //Password: user.initPassword,
      //TypeOfRole: parseInt(user.typeOfRole, 10)
    }

    if (user.id) {
      payload.Id = user.id
    }
    if (user.unlockAccount) {
      payload.LastLockedOutAt = null
    }
    api.post("Admin/SaveUser", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`User ${user.firstName} ${user.lastName} was created.`)
          this.refreshList();
          this.props.refreshAll();
        } else {
          if (response.data.message) {
            Alert.error(response.data.message)
          } else {
            Alert.error("An error occurred. User cannot be created at this time.")
          }
        }
      }).catch(error => Alert.error("There was an error creating the User."));
  }


  onDelete(userId) {
    const userName = this.getUserName(userId);
    if (!window.confirm(`Are you sure you'd like to delete ${userName}?`)) return;

    api.delete(`Admin/DeleteUser/${userId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success(`User ${userName} was deleted.`);
          this.refreshList();
        } else {
          Alert.error("An error occurred. User cannot be deleted at this time.");
        }
      }).catch(error => {
        Alert.error(`There was an error deleting ${userName}.`)
      });
  }

  onRevive(userId) {
    const userName = this.getUserName(userId);

    api.post("Admin/ReviveUser", userId)
      .then(response => {
        if (response.data.success) {
          Alert.success(`User ${userName} was revived.`);
          this.refreshList();
        } else {
          Alert.error(`An error occurred. ${userName} cannot be revived at this time.`);
        }
      }).catch(error => Alert.error(`There was an error reviving the ${userName}.`));
  }

  onResetPassword(userId) {
    let user = _.find(this.state.pagedList.list.slice(), r => { return r.id === userId });
    let payload = {
      Email: user.email
    }

    api.post("Admin/SendResetEmail", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`Password reset email was sent to ${user.email}.`);
          this.refreshList();
        } else {
          Alert.error(`An error occurred. Password reset email cannot be sent at this time.`);
        }
      }).catch(error => Alert.error(`There was an error sending reset password email for ${user.email}.`));
  }

  getUserName(userId) {
    let list = this.state.pagedList.list.slice();
    const user = _.find(list, u => {
      return u.id === userId
    })
    if (user === undefined) {
      return `User`;
    }
    return `${user.firstName} ${user.lastName}`;
  }

  render() {
    let editUser = this.state.editUser;
    return (
      <div>
        <Row>
          <Col><h5>Users</h5></Col>
          <Col className="mr-3">
            {this.state.editUser ? null : (
              <Button size="sm" color="success" className="float-right" onClick={()=>this.addUser()}>Add New User</Button>
            )}
          </Col>
        </Row>

        {this.state.message ? (
          <Alert2 color={this.state.messageColor} toggle={() => this.onDismiss()}>{this.state.message}</Alert2>
        ) : null}

        {this.state.editUser ? (
          <Card className="p-2">
            <Row className="mt-2">
              <Col>First Name: <Input type="text" maxlength="30" name="firstName" id="firstName" onChange={(e) => this.onInputChange(e, "firstName")} value={editUser.firstName} /></Col>
              <Col>Last Name: <Input type="text" maxlength="30" name="lastName" id="lastName" onChange={(e) => this.onInputChange(e, "lastName")} value={editUser.lastName} /></Col>
            </Row>
            <Row className="mt-2">
              <Col>Email: <Input type="text" maxlength="50" name="email" id="email" onChange={(e) => this.onInputChange(e, "email")} value={editUser.email || ''} /></Col>
              <Col>Role:
                <Select
                  closeMenuOnSelect={true}
                  isMulti={true}
                  value={editUser.roles}
                  options={this.state.roleList}
                  onChange={(e) => this.onSelectChange(e, "roles")}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              {editUser.id && editUser.lastLockedOutAt ? (
                <Col>
                  <label for="unlockAccount">
                    <input type="checkbox" className="mr-2" id="unlockAccount" name="unlockAccount" checked={editUser.unlockAccount} value="true" onClick={() => this.onCheckBoxChange("unlockAccount")} />
                      Unlock Account?
                    </label>
                </Col>
              ) : null}
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button size="sm" color="secondary" onClick={()=>this.onCancel()}>Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary" onClick={() => this.onSave()}>{editUser.id ? "Update" : "Save"}</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        ) : null}

        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
              <Col xs="3">
                <TextFilter
                  filterName="firstName"
                  displayName="First Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <TextFilter
                  filterName="lastName"
                  displayName="Last Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <TextFilter
                  filterName="email"
                  displayName="Email"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only?"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Locked?</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(u => (
                    <tr key={u.id}>
                      <td>{u.firstName}</td>
                      <td>{u.lastName}</td>
                      <td>{u.email}</td>
                      <td title={u.roleNameList.join(", ")}>
                        {stringHelper.truncateStringOverLength(u.roleNameList.join(", "), 20, true)}
                      </td>
                      <td>{u.lastLockedOutAt ? (
                        <FontAwesomeIcon
                          icon="lock"
                          className="ml-1 mt-0 mb-0 mr-2 pointer locked-icon"
                          title="Account is locked"
                        />
                      ) : (
                          <FontAwesomeIcon
                            icon="unlock-alt"
                            className="ml-1 mt-0 mb-0 mr-2 pointer unlocked-icon"
                            title="Account is unlocked"
                          />
                        )}
                      </td>
                      <td>
                        <ButtonGroup className="float-right">
                          {u.deactivatedAt ? (
                            <Button size="sm" className="cbdmdInfo" onClick={() => this.onRevive(u.id)}>Revive</Button>
                          ) : (
                              <React.Fragment>
                                {this.props.currentUser.isAdministrator &&
                                  <Button
                                    color="info"
                                    size="sm"
                                    tag={Link}
                                    to={{ pathname: '/impersonate', state: { email: u.email }, push: true }}
                                    disabled={this.props.impersonating}
                                    title="Impersonate"
                                    className="buttonGroupSpacing"
                                  >
                                    <FontAwesomeIcon icon="mask" />
                                  </Button>
                                }

                                <Button size="sm" color="dark" className="buttonGroupSpacing" onClick={() => this.onResetPassword(u.id)} disabled={this.state.editUser !== null}>Reset Password</Button>
                                <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onEdit(u.id)} disabled={this.state.editUser !== null} title="Edit">
                                  <FontAwesomeIcon
                                    icon="edit"
                                    className="ml-1 mt-0 mb-0 mr-1 pointer"
                                    title="Edit"
                                  />
                                </Button>
                                <Button size="sm" color="danger" className="cbdmdDanger buttonGroupSpacing" onClick={() => this.onDelete(u.id)} disabled={this.state.editUser !== null} title="Delete">
                                  <FontAwesomeIcon
                                    icon="trash-alt"
                                    className="ml-1 mt-0 mb-0 mr-1 pointer "
                                    title="Delete"
                                  />
                                </Button>
                              </React.Fragment>
                            )}
                        </ButtonGroup>
                      </td>
                    </tr>
                ))) : null}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />

          </Col>
        </Row>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/User.js